import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getLanguageSuffix } from 'src/app/common/utils/languageSuffix';

@Component({
  selector: 'app-navbar-info',
  templateUrl: './navbar-info.component.html',
  styleUrls: ['./navbar-info.component.scss'],
  standalone: false
})
export class NavbarInfoComponent {
  translate = inject(TranslateService);

  instructionSuffix: string;

  constructor() { }

  getInstructionSuffix(): string {
    return getLanguageSuffix(this.translate.currentLang)
  }
}
